import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { HeaderAppearanceEvents } from '@unicup-ticketing/core';
import { Dispatcher } from '@ngrx/signals/events';

@Component({
  selector: 'ticketing-contact',
  imports: [],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent implements OnInit {
  private readonly dispatcher = inject(Dispatcher);

  ngOnInit(): void {
    this.dispatcher.dispatch(HeaderAppearanceEvents.requestUnhero());
  }
}
